import React, { memo } from 'react';
import classnames from 'classnames';
import { Element } from 'src/components/base';

interface IProps {
    className?: string;
    children: React.ReactNode;
    breakpoint?: string;
    fluid?: boolean;
}

function Container(props: IProps) {
    const { children, breakpoint, className, fluid } = props;
    return (
        <Element
            {...props}
            className={classnames(
                'container',
                'relative',
                'mx-auto px-[16px]',
                'w-full',
                "xs:max-md:px-[10%]",
                "md:max-w-[758px] ",
                "lg:max-w-[1000px]",
                "xl:max-w-[1242px]",
                "2xl:max-w-[1484px]",
                "3xl:max-w-[1726px]",
                
                className,
                {
                    [`is-${breakpoint}`]: breakpoint,
                    ['w-[calc(100%_+_var(--padding-section)_*_2)] ml-[calc(-1_*_var(--padding-section))]']:
                        fluid,
                }
            )}
        >
            {children}
        </Element>
    );
}

export default memo(Container);
